import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    workSpaceId:"",
    isPropertyIdClear: false,
    testMode:false,
    newConversation:false,
    isOnline:true,
    createDashboardName:""
};

const userSlice = createSlice({
    name: "statics",
    initialState,
    reducers: {
        workSpaceId: (state, action) => {
            state.workSpaceId = action.payload;
        },
        isPropertyIdClear: (state, action) => {
            state.isPropertyIdClear = action.payload;
        },
        updateTestMode: (state, action) => {
            state.testMode = action.payload;
        },
        updateNewConversation: (state, action) => {
            state.newConversation = action.payload;
        },
        updateOnlineStatus: (state, action) => {
            state.isOnline = action.payload;
        },
         createDashboardName: (state, action) => {
            state.createDashboardName = action.payload;
        },
    },
});
export const { workSpaceId,isPropertyIdClear,updateTestMode,updateNewConversation, updateOnlineStatus,createDashboardName } = userSlice.actions;
export default userSlice.reducer;
